import axios from "axios";
import { setCustomerAuth, setAdminAuth } from "@/lib/auth";

// Empty/unset in production → relative "/api": the bundle calls whatever origin
// served the page. Dev keeps an absolute URL in .env (CRA dev server ≠ backend).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Login/register return 401 for bad credentials — those pages show it inline, so a
// 401 there is NOT an expired session and must not trigger the redirect below.
const AUTH_ENDPOINTS = /\/(auth\/(login|register|google)|admin\/login)$/;

api.interceptors.request.use((config) => {
  const url = config.url || "";
  // Admin + super-admin routes use the admin token; /admin/* is also restaurant-scoped.
  if (url.startsWith("/admin") || url.startsWith("/super")) {
    const adminTok = localStorage.getItem("qrdine_admin_token");
    if (adminTok) config.headers.Authorization = `Bearer ${adminTok}`;
    const rid = localStorage.getItem("qrdine_active_restaurant");
    if (rid && url.startsWith("/admin")) config.headers["X-Restaurant-Id"] = rid;
  } else {
    const custTok = localStorage.getItem("qrdine_token");
    if (custTok) config.headers.Authorization = `Bearer ${custTok}`;
  }
  return config;
});

// A 401 on a request that CARRIED a token means the stored session went stale —
// JWT expired, or token_version was bumped (password reset / forced logout). The
// token is dead, so every awaiting page would hang on a promise that never resolves
// (the /profile "Loading…" forever bug). Clear the session once, globally, and bounce
// to the right login. Verified safe: public endpoints (/menu, /categories, order-by-id)
// return 200/404 on a bad token, never 401, so guests are never redirected.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const cfg = error?.config || {};
    const status = error?.response?.status;
    const url = cfg.url || "";
    const carriedToken = !!(cfg.headers && cfg.headers.Authorization);
    if (status === 401 && carriedToken && !cfg.skipAuthRedirect && !AUTH_ENDPOINTS.test(url)) {
      const isAdmin = url.startsWith("/admin") || url.startsWith("/super");
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      if (isAdmin) {
        setAdminAuth(null);
        if (path !== "/admin/login") window.location.assign("/admin/login?session=expired");
      } else {
        setCustomerAuth(null);
        if (path !== "/login") window.location.assign("/login?session=expired");
      }
    }
    return Promise.reject(error);
  }
);
